import { parse } from 'date-fns';

import type { Dateable } from '../types';

function isNumber(number: any): number is number {
  return typeof number === 'number' && !isNaN(number);
}

const parseDateTime = (dateTime: Dateable) => {
  if (isNumber(dateTime) && dateTime < 10e9) {
    return parse(dateTime * 1000);
  }
  return parse(dateTime);
};

export default parseDateTime;
